/* eslint-disable */
const $csv = this;

// Exports an array of objects (values) to CSV using fields as the column titles
$csv.export = function(values, fields, fileName, headers) {
  const rows = [];
  if (!headers || !headers.length) headers = fields;
  rows.push(headers);
  values.forEach(value => {
    const row = fields.map(field => {
      if (
        value[field] === undefined ||
        value[field] == 'undefined' ||
        value[field] == 'null'
      ) {
        return '';
      }
      if (value[field] === 0) {
        return value[field];
      }

      return value[field] || '';
    });
    rows.push(row);
  });
  const csv = rows
    .map(row =>
      row
        .map(item => (typeof item === 'string' ? `"${item}"` : String(item)))
        .join(',')
    )
    .join('\n');
  const csvData = new Blob([csv], { type: 'text/csv' });
  const link = document.createElement('a');
  link.download = fileName;
  link.href = URL.createObjectURL(csvData);
  link.click();
};

// Imports a CSV file as an array of objects, using the first line as property keys
$csv.import = function() {
  return new Promise((resolve, reject) => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'text/csv';
    fileInput.addEventListener('change', event => {
      const reader = new FileReader();
      reader.onload = function() {
        const lines = reader.result.split('\n');
        let data = lines.map(parse);
        const fields = data.shift();
        data = data.map(row => {
          const item = {};
          fields.forEach((field, f) => {
            item[field] = row[f];
          });
          return item;
        });
        resolve(data);
      };
      reader.readAsText(fileInput.files[0]);
    });
    fileInput.click();
  });
};

function parse(row) {
  let insideQuote = false;
  const entries = [];
  let entry = [];
  row.split('').forEach(character => {
    if (character === '"') {
      insideQuote = !insideQuote;
    } else if (character == ',' && !insideQuote) {
      entries.push(entry.join(''));
      entry = [];
    } else {
      entry.push(character);
    }
  });
  entries.push(entry.join(''));
  return entries;
}

module.exports = $csv;
